import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withKeys as _withKeys, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "font-semibold flex gap-1.5 items-center border rounded-md border-gray-300 shadow-sm py-1 pl-2.5 pr-2 h-[38px] w-[fit-content]"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "max-w-[1040px]" }
const _hoisted_10 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_11 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_12 = { class: "flex justify-end -m-1" }
const _hoisted_13 = { class: "text-gray-900" }
const _hoisted_14 = { class: "text-gray-900" }
const _hoisted_15 = { class: "flex gap-4 items-center" }
const _hoisted_16 = { class: "flex w-full justify-end align-center" }
const _hoisted_17 = {
  key: 1,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-gray-500"
}
const _hoisted_19 = { class: "max-w-[1040px]" }
const _hoisted_20 = { class: "flex items-center justify-between gap-6" }
const _hoisted_21 = {
  key: 0,
  class: "border-t border-gray-100 pt-5"
}
const _hoisted_22 = { class: "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-6" }
const _hoisted_23 = { class: "max-w-[1040px]" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = {
  key: 0,
  class: "cursor-move variant-handle -ml-4 px-3 py-4 -my-2"
}
const _hoisted_26 = {
  key: 0,
  class: "flex gap-2 draggable-invisible"
}
const _hoisted_27 = { class: "flex items-center h-8 w-full" }
const _hoisted_28 = { class: "flex-1 min-w-0" }
const _hoisted_29 = { class: "truncate" }
const _hoisted_30 = {
  key: 0,
  class: "font-normal text-gray-500 ml-1"
}
const _hoisted_31 = {
  key: 1,
  class: "font-normal text-gray-500 ml-1"
}
const _hoisted_32 = {
  key: 1,
  class: "text-gray-500 ml-2 shrink-0 text-right"
}
const _hoisted_33 = {
  key: 2,
  class: "flex justify-end align-center draggable-invisible ml-2"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "text-center text-gray-500 py-3"
}
const _hoisted_36 = { class: "max-w-[1040px]" }
const _hoisted_37 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_38 = { class: "flex justify-end -m-1" }
const _hoisted_39 = { class: "font-semibold text-gray-700" }
const _hoisted_40 = { class: "flex w-full justify-end align-center" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "text-center rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_43 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_44 = { class: "max-w-[1040px]" }
const _hoisted_45 = { class: "flex flex-col gap-4" }
const _hoisted_46 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_47 = {
  key: 1,
  class: "max-w-[1040px]"
}
const _hoisted_48 = {
  key: 1,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_49 = { class: "flex justify-end" }
const _hoisted_50 = { class: "font-semibold text-gray-700 truncate" }
const _hoisted_51 = { class: "truncate" }
const _hoisted_52 = { class: "truncate" }
const _hoisted_53 = { class: "flex justify-end" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-6" }
const _hoisted_56 = { class: "max-w-[1040px]" }
const _hoisted_57 = { class: "flex items-center justify-between gap-6" }
const _hoisted_58 = {
  key: 0,
  class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5"
}
const _hoisted_59 = { class: "flex gap-2" }
const _hoisted_60 = { class: "flex items-start gap-2 p-3 bg-gray-50 rounded-md border border-gray-200" }
const _hoisted_61 = { class: "flex gap-3" }
const _hoisted_62 = { class: "font-semibold text-gray-700 truncate" }
const _hoisted_63 = { class: "truncate text-gray-500" }
const _hoisted_64 = { class: "flex gap-3" }

import { MenuItem } from '@headlessui/vue'
import { Bars3Icon, InformationCircleIcon, LockClosedIcon, XCircleIcon } from '@heroicons/vue/24/outline'
import { Sortable } from '@shopify/draggable'
import { computed, reactive, ref, watch } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'

import FranchiseLockNotice from '@/components/franchise/FranchiseLockNotice.vue'
import CPSPModal from '@/components/neue/CPSPModal'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import SegmentedControl from '@/components/neue/SegmentedControl.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import ParsleyLockNotice from '@/components/parsley/ParsleyLockNotice.vue'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { buildOverrideRows, overrideAttributes } from '@/composables/variantIngredientOverrides'
import { ingredientMeasurementOptions } from '@/config/ingredientMeasurements'
import {
  FRANCHISE_EDITABLE_OPTION_KEYS,
  FRANCHISE_EDITABLE_PRODUCT_KEYS,
  franchiseEditable,
  franchiseRecordLockText,
  isFranchiseManaged,
  nextFranchiseManaged
} from '@/helpers/franchiseManaged'
import { getScrollParent } from '@/helpers/getScrollParent'
import { isContainsLabel, isParsleyLocked, nextParsleyLink } from '@/helpers/parsley'
import {
  formatPriceDelta,
  priceCentsFrom,
  priceDeltaSignOptions,
  splitPriceCents,
  UPCHARGE
} from '@/helpers/priceDelta'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'
import StoreSectionsNav from '@/view/store/StoreSectionsNav'


export default {
  __name: 'ProductNeue',
  setup(__props) {

const priceListColumns = [{ width: 'minmax(140px, 1fr)' }, { width: 'minmax(100px, 1fr)' }, { width: '80px' }]
const storePairColumns = [{ width: 'minmax(140px, 1fr)' }, { width: 'minmax(120px, 1fr)' }, { width: '140px' }]
const ingredientColumns = [
  { width: 'minmax(140px, 1fr)' },
  { width: 'minmax(100px, 1fr)' },
  { width: 'minmax(100px, 1fr)' },
  { width: '140px' }
]
const optionIngredientColumns = [{ width: 'minmax(120px, 1fr)' }, { width: 'minmax(100px, 1fr)' }, { width: '160px' }]

const box = ref(null)
const uploader = ref(null)
const route = useRoute()
const router = useRouter()
const productId = computed(() => route.params.productId ?? route.params.id)
const storeId = computed(() => (route.params.productId ? route.params.id : null))
const parent = computed(() =>
  storeId.value
    ? { name: 'Product availability', link: `/store/stores/${storeId.value}/availability` }
    : { name: 'Product library', link: '/store/products' }
)
const productPath = id => (storeId.value ? `/store/stores/${storeId.value}/products/${id}` : `/store/products/${id}`)
const isFood = computed(() => product.value?.attributes.type === 'FoodProduct')
const productTabs = computed(() =>
  [
    { id: 'main', name: 'Main info' },
    { id: 'pricing', name: 'Pricing' },
    { id: 'inventory', name: 'Inventory' },
    { id: 'variants', name: 'Variants' },
    { id: 'stores', name: 'Stores' },
    { id: 'labels', name: 'Labels' },
    isFood.value && { id: 'nutrition', name: 'Nutrition' },
    { id: 'actions', name: 'Actions' }
  ].filter(Boolean)
)
const { activeTab, sections: productSections } = useRouteTabs(
  productTabs,
  computed(() => productPath(productId.value))
)
const doneLink = computed(() => (storeId.value ? `/store/stores/${storeId.value}` : '/store/products'))
const product = computed(() => mapRelationship({ type: 'product', id: productId.value }))
// While locked, Parsley owns nutrition, ingredients and Contains labels. The
// API ignores them too, so a stale tab cannot overwrite Parsley's data.
//
// An unrelated request (the autofill fallback product search, for one) can restore this
// product's own store record without the parsley_link attribute at all, which tells us
// nothing about the link and must not unlock the page. rememberedParsleyLink only changes
// when a record actually carries the key (an object, or null); onBeforeRouteUpdate below
// clears it before a different product's record is read, so one product's lock can never
// leak onto another.
const rememberedParsleyLink = ref(null)
watch(product, current => (rememberedParsleyLink.value = nextParsleyLink(rememberedParsleyLink.value, current)), {
  immediate: true
})
const parsleyLink = computed(() => rememberedParsleyLink.value)
const parsleyLocked = computed(() => isParsleyLocked({ attributes: { parsley_link: parsleyLink.value } }))
// While the franchise's menu propagation is on, the franchise owns everything on a managed product
// but its inventory, price lists and autofill fallback, and the API drops the rest from updates. The
// same sparse-response guard as the Parsley link applies, and the route update below clears it too.
const rememberedFranchiseLock = ref(null)
watch(
  product,
  current => (rememberedFranchiseLock.value = nextFranchiseManaged(rememberedFranchiseLock.value, current)),
  { immediate: true }
)
const franchiseManaged = computed(() => Boolean(rememberedFranchiseLock.value))
const franchiseName = computed(() => rememberedFranchiseLock.value?.franchiseName ?? null)
const nutritionLocked = computed(() => parsleyLocked.value || franchiseManaged.value)
const labelLocked = label => franchiseManaged.value || (parsleyLocked.value && isContainsLabel(label))
// What a product update may carry: everything, or on a managed product only what the franchisee owns.
const productUpdate = attributes =>
  franchiseManaged.value ? franchiseEditable(attributes, FRANCHISE_EDITABLE_PRODUCT_KEYS) : attributes

const hasUnsavedChanges = ref(false)
const loading = ref(true)
const aiLoading = ref(false)

const local = reactive({ nutritional: {}, priceListValues: {} })
const modalPair = ref(null)
const newPairModal = reactive({ open: false })
const ingredientsModal = reactive({ open: false })
const variantModal = reactive({ open: false })
const optionModal = reactive({ open: false })
const priceListModal = reactive({ open: false })
const sortables = ref([])

const discard = () => {
  local.name = product.value.attributes.product_name
  local.description = product.value.attributes.description
  local.sku = product.value.attributes.merchant_sku

  local.startingQuantity = product.value.attributes.starting_quantity
  local.quantityName = product.value.attributes.unique_quantity_name_single
  local.quantityStep = product.value.attributes.step

  local.defaultPrice = (product.value.attributes.default_price?.cents / 100).toFixed(2)
  local.giftCardValue = (product.value.attributes.account_credit_value?.cents / 100).toFixed(2)
  local.priceListValues = {}
  for (const list of priceLists.value) {
    if (listPair(list)) {
      local.priceListValues[list.id] = (listPair(list).attributes.price?.cents / 100).toFixed(2)
    }
  }

  local.taxCode = product.value.attributes.tax_code

  local.inventoryLimit = product.value.attributes.inventory_remaining

  const nutritional = mapRelationship(product.value.relationships.nutritional_information.data)
  if (nutritional) {
    local.nutritional.servingSize = nutritional.attributes.serving_size
    local.nutritional.servingSizeName = nutritional.attributes.serving_size_title_singular
    local.nutritional.servingsPerContainer = nutritional.attributes.servings_per_container
    local.nutritional.calories = nutritional.attributes.calories
    local.nutritional.totalFat = nutritional.attributes.total_fat
    local.nutritional.saturatedFat = nutritional.attributes.saturated_fat
    local.nutritional.transFat = nutritional.attributes.trans_fat
    local.nutritional.protein = nutritional.attributes.protein
    local.nutritional.totalCarbs = nutritional.attributes.total_carbs
    local.nutritional.dietaryFiber = nutritional.attributes.dietary_fiber
    local.nutritional.sugars = nutritional.attributes.sugars
    local.nutritional.addedSugar = nutritional.attributes.added_sugar
    local.nutritional.cholesterol = nutritional.attributes.cholesterol
    local.nutritional.sodium = nutritional.attributes.sodium
    local.nutritional.iron = nutritional.attributes.iron
    local.nutritional.vitaminD = nutritional.attributes.vitamin_d
    local.nutritional.vitaminC = nutritional.attributes.vitamin_c
  }

  hasUnsavedChanges.value = false
  loading.value = false
  initSortables()
}
const load = id => {
  loading.value = true
  Promise.all([
    api.call(
      'GET',
      `products/${id}?included=${[
        'attachments',
        'replace_with_product',
        'label_product_pairs',
        'category_product_store_pairs',
        'category_product_store_pairs.store',
        'category_product_store_pairs.category',
        'category_product_store_pairs.fulfillment_availabilities',
        'category_product_store_pairs.product_store_membership_prices',
        'category_product_store_pairs.product_store_membership_prices.membership_tier',
        'ingredients',
        'variants',
        'variants.variant_options',
        'variants.variant_options.nutritional_information',
        'variants.variant_options.ingredients',
        'nutritional_information',
        'product_price_list_pairs'
      ].join(',')}`
    ),
    api.call('GET', 'price_lists?included=product_price_list_pairs')
  ]).then(discard)
}
load(productId.value)
onBeforeRouteUpdate((to, from) => {
  const next = to.params.productId ?? to.params.id
  if (next === (from.params.productId ?? from.params.id)) return
  // Clear before the new product's own record is read, so this product's lock can never
  // apply to the next one, even if the next id is already cached in the store without the
  // parsley_link key (fetched earlier through a lighter endpoint, say).
  rememberedParsleyLink.value = null
  rememberedFranchiseLock.value = null
  load(next)
})

const images = computed(() =>
  mapRelationships(product.value?.relationships.attachments.data).sort(
    (a, b) => a.attributes.order - b.attributes.order
  )
)
const taxCodes = computed(() => mapType('product_tax_code'))
const selectedTaxCode = computed(() => taxCodes.value.find(x => x.attributes.code === local.taxCode))
const fallbackProduct = computed(() => mapRelationship(product.value?.relationships.replace_with_product.data))
const labels = computed(() => mapType('label'))
const ingredients = computed(() =>
  mapRelationships(product.value?.relationships.ingredients.data).sort((a, b) => a.id - b.id)
)
const stores = computed(() => mapType('store'))
const pairs = computed(() => mapRelationships(product.value?.relationships.category_product_store_pairs.data))
const variants = computed(() =>
  mapRelationships(product.value?.relationships.variants.data).sort((a, b) => a.attributes.order - b.attributes.order)
)
const priceLists = computed(() => mapType('price_list'))
const priceListPairs = computed(() => mapRelationships(product.value?.relationships.product_price_list_pairs.data))
const listPair = list => priceListPairs.value.find(x => x.relationships.price_list.data.id == list.id)
const pairStore = pair => mapRelationship(pair?.relationships.store.data)
const pairCategory = pair => mapRelationship(pair?.relationships.category.data)
const storeCategories = store =>
  mapRelationships(store?.relationships.categories.data).filter(x => x.attributes.type !== 'UpsellCategory')
const variantOptions = variant =>
  mapRelationships(variant?.relationships.variant_options.data)
    .map(option => ({
      ...option,
      nutritional_information: mapRelationship(option?.relationships.nutritional_information.data)
    }))
    .sort((a, b) => a.attributes.order - b.attributes.order)

api.call('GET', 'products/tax_codes')
api.call('GET', 'labels?included=none')
api.call('GET', 'stores?included=categories')

const nutritionAttributes = () => ({
  serving_size: local.nutritional.servingSize,
  serving_size_title_singular: local.nutritional.servingSizeName,
  servings_per_container: local.nutritional.servingsPerContainer,
  calories: local.nutritional.calories,
  total_fat: local.nutritional.totalFat,
  saturated_fat: local.nutritional.saturatedFat,
  trans_fat: local.nutritional.transFat,
  protein: local.nutritional.protein,
  total_carbs: local.nutritional.totalCarbs,
  dietary_fiber: local.nutritional.dietaryFiber,
  sugars: local.nutritional.sugars,
  added_sugar: local.nutritional.addedSugar,
  cholesterol: local.nutritional.cholesterol,
  sodium: local.nutritional.sodium,
  iron: local.nutritional.iron,
  vitamin_d: local.nutritional.vitaminD,
  vitamin_c: local.nutritional.vitaminC
})

const save = () => {
  api.call('PUT', `products/${productId.value}?included=nutritional_information,product_price_list_pairs`, {
    product: productUpdate({
      product_name: local.name,
      description: local.description,
      merchant_sku: local.sku,

      starting_quantity: local.startingQuantity,
      unique_quantity_name_single: local.quantityName,
      step: local.quantityStep,

      default_price_cents: Math.round(local.defaultPrice * 100),
      account_credit_value_cents: Math.round(local.giftCardValue * 100),

      tax_code: local.taxCode,

      set_quantity_changes_attributes: [{ value: local.inventoryLimit }],

      ...(nutritionLocked.value ? {} : { nutritional_information_attributes: nutritionAttributes() }),

      product_price_list_pairs_attributes: Object.entries(local.priceListValues).map(([listId, value]) => ({
        _destroy: value == null,
        id: listPair({ id: listId })?.id,
        price_list_id: listId,
        price_cents: Math.round(value * 100)
      }))
    })
  })

  hasUnsavedChanges.value = false
}

const setAttribute = (attr, value) => {
  const attributes = productUpdate({ [attr]: value })
  if (!Object.keys(attributes).length) return
  api.call('PUT', `products/${productId.value}?included=none`, { product: attributes })
}

const selectAutofillFallback = item => {
  api.call('PUT', `products/${productId.value}?included=replace_with_product`, {
    product: {
      replace_with_product_id: item.id ?? null
    }
  })
}

const labelChecked = label => {
  const labelPairs = mapRelationships(product.value?.relationships.label_product_pairs.data)
  return labelPairs.some(x => x.attributes.label_id == label.id)
}
const toggleLabel = label => {
  if (labelLocked(label)) return
  const labelPairs = mapRelationships(product.value?.relationships.label_product_pairs.data)
  const pair = labelPairs.find(x => x.attributes.label_id == label.id)
  if (pair) {
    api.call('PUT', `products/${productId.value}?included=label_product_pairs`, {
      product: { label_product_pairs_attributes: [{ id: pair.id, _destroy: true }] }
    })
  } else {
    api.call('PUT', `products/${productId.value}?included=label_product_pairs`, {
      product: { label_product_pairs_attributes: [{ label_id: label.id }] }
    })
  }
}
const createLabel = () => {
  api.call('POST', 'labels', { label: { label_name: local.newLabel } }).then(response => {
    toggleLabel(response.data.data)
  })
  local.newLabel = null
}

const editPair = pair => {
  modalPair.value = pair
  local.cpspModalOpen = true
}
const addPair = () => {
  newPairModal.open = true
  newPairModal.store = null
  newPairModal.category = null
}
const saveNewPair = () => {
  api
    .call('POST', `stores/${newPairModal.store}/category_product_store_pairs`, {
      category_product_store_pair: {
        category_id: newPairModal.category,
        product_id: productId.value
      }
    })
    .then(() => {
      api.call(
        'GET',
        `products/${productId.value}?included=${[
          'category_product_store_pairs',
          'category_product_store_pairs.product_store_membership_prices',
          'category_product_store_pairs.product_store_membership_prices.membership_tier'
        ].join(',')}`
      )
    })
  newPairModal.open = false
}
const deletePair = pair => {
  api.call('DELETE', `stores/${pairStore(pair).id}/category_product_store_pairs/${pair.id}`).then(() => {
    api.call('GET', `products/${productId.value}?included=category_product_store_pairs`)
  })
}

const addIngredient = () => {
  if (nutritionLocked.value) return
  ingredientsModal.open = true
  ingredientsModal.id = null
  ingredientsModal.name = ''
  ingredientsModal.contains = ''
  ingredientsModal.measurement = ''
  ingredientsModal.amount = ''
}
const editIngredient = ingredient => {
  if (nutritionLocked.value) return
  ingredientsModal.open = true
  ingredientsModal.id = ingredient.id
  ingredientsModal.name = ingredient.attributes.name
  ingredientsModal.contains = ingredient.attributes.contains
  ingredientsModal.measurement = ingredient.attributes.measurement
  ingredientsModal.amount = ingredient.attributes.amount
}
const saveIngredientsModal = () => {
  if (nutritionLocked.value) return
  if (!ingredientsModal.name) return
  ingredientsModal.open = false
  api.call('PUT', `products/${productId.value}?included=ingredients`, {
    product: {
      ingredients_attributes: [
        {
          id: ingredientsModal.id,
          name: ingredientsModal.name,
          contains: ingredientsModal.contains,
          measurement: ingredientsModal.measurement,
          amount: ingredientsModal.amount
        }
      ]
    }
  })
}
const deleteIngredient = ingredient => {
  if (nutritionLocked.value) return
  api.call('PUT', `products/${productId.value}?included=ingredients`, {
    product: {
      ingredients_attributes: [{ id: ingredient.id, _destroy: true }]
    }
  })
}

const initSortables = () => {
  for (const sortable of sortables.value) sortable.destroy()
  sortables.value = []
  // Variant and option order is the franchise's on a managed product.
  if (franchiseManaged.value) return

  sortables.value.push(
    new Sortable(document.querySelector('#sortable-variants .tablist-body'), { handle: '.variant-handle' }).on(
      'sortable:stop',
      e => {
        if (e.data.oldIndex === e.data.newIndex) return
        const list = variants.value
        const moved = list.splice(e.data.oldIndex, 1)[0]
        list.splice(e.data.newIndex, 0, moved)
        api.call('PUT', `products/${productId.value}?included=variants`, {
          product: {
            variants_attributes: list.map((x, i) => ({
              id: x.id,
              order: i
            }))
          }
        })
      }
    )
  )

  for (const variant of variants.value) {
    sortables.value.push(
      new Sortable(document.querySelectorAll(`.sortable-options-${variant.id}`), { handle: '.option-handle' }).on(
        'sortable:stop',
        e => {
          if (e.data.oldIndex === e.data.newIndex) return
          const list = variantOptions(mapRelationship(variant)) // mapping again to get a fresh list of options from Vuex
          const moved = list.splice(e.data.oldIndex, 1)[0]
          list.splice(e.data.newIndex, 0, moved)
          api.call('PUT', `products/${productId.value}?included=variants,variants.variant_options`, {
            product: {
              variants_attributes: [
                {
                  id: variant.id,
                  variant_options_attributes: list.map((x, i) => ({
                    id: x.id,
                    order: i
                  }))
                }
              ]
            }
          })
        }
      )
    )
  }
}

const addVariant = () => {
  variantModal.id = null
  variantModal.name = ''
  variantModal.required = true
  variantModal.quantityOption = 'choose_one'
  variantModal.minimum = ''
  variantModal.maximum = ''
  variantModal.visible = true
  variantModal.open = true
}
const editVariant = variant => {
  variantModal.id = variant.id
  variantModal.name = variant.attributes.name
  variantModal.required = variant.attributes.required
  variantModal.quantityOption = variant.attributes.quantity_option
  variantModal.minimum = variant.attributes.minimum
  variantModal.maximum = variant.attributes.maximum
  variantModal.visible = variant.attributes.is_visible
  variantModal.open = true
}
const saveVariantModal = () => {
  variantModal.open = false
  api
    .call('PUT', `products/${productId.value}?included=variants`, {
      product: {
        variants_attributes: [
          {
            id: variantModal.id,
            ...(variantModal.id === null && {
              order: variants.value.length
            }),
            name: variantModal.name,
            required: variantModal.required,
            quantity_option: variantModal.quantityOption,
            minimum: variantModal.minimum,
            maximum: variantModal.maximum,
            is_visible: variantModal.visible
          }
        ]
      }
    })
    .then(initSortables)
}
const deleteVariant = variant => {
  api.call('PUT', `products/${productId.value}?included=variants`, {
    product: {
      variants_attributes: [{ id: variant.id, _destroy: true }]
    }
  })
}

const addOption = variant => {
  optionModal.id = null
  optionModal.variantId = variant.id
  optionModal.name = ''
  optionModal.matchName = ''
  optionModal.description = ''
  optionModal.price = ''
  optionModal.priceSign = UPCHARGE
  optionModal.hasQuantityLimit = false
  optionModal.inventoryRemaining = null
  optionModal.hasNutritionalInfo = false
  optionModal.nutritional_information = {
    serving_size: null,
    serving_size_title_singular: null,
    servings_per_container: null,
    calories: null,
    total_fat: null,
    saturated_fat: null,
    trans_fat: null,
    protein: null,
    total_carbs: null,
    dietary_fiber: null,
    sugars: null,
    added_sugar: null,
    cholesterol: null,
    sodium: null,
    iron: null,
    vitamin_d: null,
    vitamin_c: null
  }
  optionModal.ingredientRows = buildOverrideRows(ingredients.value, [])
  optionModal.open = true
}
const optionIngredientOverrides = option => mapRelationships(option.relationships.ingredients?.data ?? [])
const hasIngredientOverrides = option => optionIngredientOverrides(option).length > 0
const editOption = option => {
  optionModal.id = option.id
  optionModal.variantId = option.relationships.variant.data.id
  optionModal.name = option.attributes.name
  optionModal.matchName = option.attributes.autofill_preference_override
  optionModal.description = option.attributes.description
  const { sign, amount } = splitPriceCents(option.attributes.price?.cents)
  optionModal.priceSign = sign
  optionModal.price = amount
  optionModal.hasQuantityLimit = option.attributes.has_quantity_limit || false
  optionModal.inventoryRemaining = option.attributes.inventory_remaining || null
  optionModal.open = true
  const nutritional = mapRelationship(option?.relationships.nutritional_information.data)
  optionModal.nutritional_information = {
    serving_size: nutritional?.attributes.serving_size || null,
    serving_size_title_singular: nutritional?.attributes.serving_size_title_singular || null,
    servings_per_container: nutritional?.attributes.servings_per_container || null,
    calories: nutritional?.attributes.calories || null,
    total_fat: nutritional?.attributes.total_fat || null,
    saturated_fat: nutritional?.attributes.saturated_fat || null,
    trans_fat: nutritional?.attributes.trans_fat || null,
    protein: nutritional?.attributes.protein || null,
    total_carbs: nutritional?.attributes.total_carbs || null,
    dietary_fiber: nutritional?.attributes.dietary_fiber || null,
    sugars: nutritional?.attributes.sugars || null,
    added_sugar: nutritional?.attributes.added_sugar || null,
    cholesterol: nutritional?.attributes.cholesterol || null,
    sodium: nutritional?.attributes.sodium || null,
    iron: nutritional?.attributes.iron || null,
    vitamin_d: nutritional?.attributes.vitamin_d || null,
    vitamin_c: nutritional?.attributes.vitamin_c || null
  }
  // Check if any nutritional value exists
  optionModal.hasNutritionalInfo = Object.values(optionModal.nutritional_information).some(value => value !== null)
  optionModal.ingredientRows = buildOverrideRows(ingredients.value, optionIngredientOverrides(option))
}
const clearNutritionalInfo = () => {
  optionModal.nutritional_information = {
    serving_size: null,
    serving_size_title_singular: null,
    servings_per_container: null,
    calories: null,
    total_fat: null,
    saturated_fat: null,
    trans_fat: null,
    protein: null,
    total_carbs: null,
    dietary_fiber: null,
    sugars: null,
    added_sugar: null,
    cholesterol: null,
    sodium: null,
    iron: null,
    vitamin_d: null,
    vitamin_c: null
  }
}
// On a managed product an option keeps only its id and inventory; the API drops the rest anyway.
const optionUpdate = attributes =>
  franchiseManaged.value ? franchiseEditable(attributes, FRANCHISE_EDITABLE_OPTION_KEYS) : attributes
const saveOptionModal = () => {
  optionModal.open = false
  const options = variantOptions(mapRelationship({ type: 'variant', id: optionModal.variantId }))
  api
    .call(
      'PUT',
      `products/${productId.value}?included=variants,variants.variant_options,variants.variant_options.nutritional_information,variants.variant_options.ingredients`,
      {
        product: {
          variants_attributes: [
            {
              id: optionModal.variantId,
              variant_options_attributes: [
                optionUpdate({
                  id: optionModal.id,
                  ...(optionModal.id === null && {
                    order: options.length
                  }),
                  name: optionModal.name,
                  autofill_preference_override: optionModal.matchName,
                  description: optionModal.description,
                  price_cents: priceCentsFrom(optionModal.priceSign, optionModal.price),
                  has_quantity_limit: optionModal.hasQuantityLimit,
                  ingredients_attributes: overrideAttributes(optionModal.ingredientRows ?? []),
                  set_quantity_changes_attributes: [
                    {
                      value: optionModal.inventoryRemaining
                    }
                  ],
                  nutritional_information_attributes: optionModal.hasNutritionalInfo
                    ? {
                        serving_size: optionModal.nutritional_information.serving_size,
                        serving_size_title_singular: optionModal.nutritional_information.serving_size_title_singular,
                        servings_per_container: optionModal.nutritional_information.servings_per_container,
                        calories: optionModal.nutritional_information.calories,
                        total_fat: optionModal.nutritional_information.total_fat,
                        saturated_fat: optionModal.nutritional_information.saturated_fat,
                        trans_fat: optionModal.nutritional_information.trans_fat,
                        protein: optionModal.nutritional_information.protein,
                        total_carbs: optionModal.nutritional_information.total_carbs,
                        dietary_fiber: optionModal.nutritional_information.dietary_fiber,
                        sugars: optionModal.nutritional_information.sugars,
                        added_sugar: optionModal.nutritional_information.added_sugar,
                        cholesterol: optionModal.nutritional_information.cholesterol,
                        sodium: optionModal.nutritional_information.sodium,
                        iron: optionModal.nutritional_information.iron,
                        vitamin_d: optionModal.nutritional_information.vitamin_d,
                        vitamin_c: optionModal.nutritional_information.vitamin_c
                      }
                    : {
                        serving_size: null,
                        serving_size_title_singular: null,
                        servings_per_container: null,
                        calories: null,
                        total_fat: null,
                        saturated_fat: null,
                        trans_fat: null,
                        protein: null,
                        total_carbs: null,
                        dietary_fiber: null,
                        sugars: null,
                        added_sugar: null,
                        cholesterol: null,
                        sodium: null,
                        iron: null,
                        vitamin_d: null,
                        vitamin_c: null
                      }
                })
              ]
            }
          ]
        }
      }
    )
    .then(initSortables)
}
const deleteOption = option => {
  api.call('PUT', `products/${productId.value}?included=variants,variants.variant_options`, {
    product: {
      variants_attributes: [
        {
          id: option.relationships.variant.data.id,
          variant_options_attributes: [{ id: option.id, _destroy: true }]
        }
      ]
    }
  })
}

const changeImages = images => {
  if (franchiseManaged.value) return
  api.call('PUT', `products/${productId.value}?included=attachments`, {
    product: {
      attachments_attributes: images
    }
  })
}

const addPriceList = () => {
  priceListModal.name = ''
  priceListModal.open = true
}
const savePriceListModal = () => {
  priceListModal.open = false
  api.call('POST', 'price_lists', {
    price_list: { price_list_name: priceListModal.name }
  })
}
const deletePriceList = list => {
  if (!confirm(`Deleting ${list.attributes.price_list_name} will delete it for ALL products. Delete?`)) return
  api.call('DELETE', `price_lists/${list.id}`)
}
const togglePriceList = (list, state) => {
  if (state) {
    local.priceListValues[list.id] = local.defaultPrice
  } else {
    local.priceListValues[list.id] = null
  }
  hasUnsavedChanges.value = true
}

const deleteProduct = () => {
  if (franchiseManaged.value) return
  if (!confirm(`Delete ${local.name}?`)) return
  api.call('DELETE', `products/${productId.value}`).then(() => router.push(doneLink.value))
}

const copyProduct = () => {
  api.call('POST', `products/${productId.value}/copies`).then(async response => {
    await router.push(`${productPath(response.data.data.id)}/main`)
    getScrollParent(box.value).scrollTop = 0
  })
}

const useAI = async () => {
  aiLoading.value = true
  try {
    await api.call('POST', `products/${productId.value}/ai_macros?included=nutritional_information`)

    const nutritional = mapRelationship(product.value.relationships.nutritional_information.data)
    if (nutritional) {
      local.nutritional.servingSize = nutritional.attributes.serving_size
      local.nutritional.servingSizeName = nutritional.attributes.serving_size_title_singular
      local.nutritional.servingsPerContainer = nutritional.attributes.servings_per_container
      local.nutritional.calories = nutritional.attributes.calories
      local.nutritional.totalFat = nutritional.attributes.total_fat
      local.nutritional.saturatedFat = nutritional.attributes.saturated_fat
      local.nutritional.transFat = nutritional.attributes.trans_fat
      local.nutritional.protein = nutritional.attributes.protein
      local.nutritional.totalCarbs = nutritional.attributes.total_carbs
      local.nutritional.dietaryFiber = nutritional.attributes.dietary_fiber
      local.nutritional.sugars = nutritional.attributes.sugars
      local.nutritional.addedSugar = nutritional.attributes.added_sugar
      local.nutritional.cholesterol = nutritional.attributes.cholesterol
      local.nutritional.sodium = nutritional.attributes.sodium
      local.nutritional.iron = nutritional.attributes.iron
      local.nutritional.vitaminD = nutritional.attributes.vitamin_d
      local.nutritional.vitaminC = nutritional.attributes.vitamin_c
    }
  } catch (error) {
    console.error('AI request failed:', error)
  } finally {
    aiLoading.value = false
  }
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_InputField = _resolveComponent("InputField")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_ImageUploaderNeue = _resolveComponent("ImageUploaderNeue")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_router_link = _resolveComponent("router-link")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_NeueCheckbox = _resolveComponent("NeueCheckbox")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, _createSlots({
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        parent: parent.value,
        "save-status": true,
        text: local.name,
        sections: _unref(productSections)
      }, null, 8, ["parent", "text", "sections"]),
      _createVNode(_component_SaveBar, {
        "has-unsaved-changes": hasUnsavedChanges.value,
        onOnDiscard: discard,
        onOnSave: save
      }, null, 8, ["has-unsaved-changes"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "box",
        ref: box,
        class: "flex flex-col justify-between h-full"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (franchiseManaged.value)
                ? (_openBlock(), _createBlock(FranchiseLockNotice, {
                    key: 0,
                    class: "max-w-[1040px]",
                    "franchise-name": franchiseName.value
                  }, null, 8, ["franchise-name"]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(SettingsSection, {
                  title: "Details",
                  description: "How this product is named and described to customers, and the SKU your team knows it by."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: local.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((local.name) = $event)),
                      name: "Name",
                      disabled: franchiseManaged.value,
                      onInput: _cache[1] || (_cache[1] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_InputArea, {
                      modelValue: local.description,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((local.description) = $event)),
                      name: "Description",
                      disabled: franchiseManaged.value,
                      onInput: _cache[3] || (_cache[3] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_InputField, {
                      modelValue: local.sku,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((local.sku) = $event)),
                      name: "SKU",
                      class: "sm:max-w-xs",
                      disabled: franchiseManaged.value,
                      onInput: _cache[5] || (_cache[5] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Fulfillment",
                  description: "Whether customers pick a pickup or delivery option when this product is in their cart.",
                  flush: ""
                }, {
                  default: _withCtx(() => [
                    _cache[98] || (_cache[98] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Requires a fulfillment method at checkout"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Turn off for products that are never picked up or delivered, like gift cards. ")
                    ], -1)),
                    _createVNode(_component_NeueToggle, {
                      "model-value": product.value?.attributes.requires_fulfillment,
                      "aria-label": "Requires a fulfillment method at checkout",
                      disabled: franchiseManaged.value,
                      onChange: _cache[6] || (_cache[6] = e => setAttribute('requires_fulfillment', e))
                    }, null, 8, ["model-value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Autofill fallback",
                  description: "The product autofill puts in a cart instead when this one is unavailable."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _cache[100] || (_cache[100] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Autofill fallback product", -1)),
                      (!fallbackProduct.value)
                        ? (_openBlock(), _createBlock(_component_InlineSearchSelect, {
                            key: 0,
                            "helper-text": { typingPrompt: 'Search for products', noResult: 'No products found' },
                            "search-endpoint": "products/search?included=none",
                            "search-request": { search: { text: local.autofillFallbackQuery } },
                            onOnSearch: _cache[7] || (_cache[7] = x => (local.autofillFallbackQuery = x)),
                            onOnResults: _cache[8] || (_cache[8] = x => (local.autofillFallbackResults = x))
                          }, {
                            searchResults: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(local.autofillFallbackResults, (item) => {
                                return (_openBlock(), _createBlock(_unref(MenuItem), {
                                  key: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      class: "group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors text-gray-700",
                                      onClick: $event => (selectAutofillFallback(item))
                                    }, _toDisplayString(item.attributes.product_name), 9, _hoisted_3)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["search-request"]))
                        : _createCommentVNode("", true),
                      (fallbackProduct.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: '/store/products/' + fallbackProduct.value.id
                            }, _toDisplayString(fallbackProduct.value.attributes.product_name), 9, _hoisted_5),
                            _createVNode(_unref(XCircleIcon), {
                              class: "inline cursor-pointer h-6 w-6",
                              onClick: selectAutofillFallback
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-sm text-gray-500", fallbackProduct.value ? 'mt-1' : 'mt-2'])
                      }, [
                        (fallbackProduct.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                              _createTextVNode(" When " + _toDisplayString(local.name) + " is unavailable, ", 1),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(fallbackProduct.value.attributes.product_name), 1),
                              _cache[99] || (_cache[99] = _createTextVNode(" will be displayed in stores instead. ", -1))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, " Select other product for replacement when " + _toDisplayString(local.name) + " is not available for autofill (must be displayed in store at time of replacement). ", 1))
                      ], 2)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Images",
                  description: "Photos customers see on the product card and the product page."
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ImageUploaderNeue, {
                      key: String(franchiseManaged.value),
                      files: images.value,
                      editable: !franchiseManaged.value,
                      onChange: changeImages
                    }, null, 8, ["files", "editable"]))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'main']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createVNode(SettingsSection, {
                  title: "Price",
                  description: "What customers pay for one of this product before any discounts.",
                  onInput: _cache[11] || (_cache[11] = $event => (hasUnsavedChanges.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_InputField, {
                        modelValue: local.defaultPrice,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((local.defaultPrice) = $event)),
                        prefix: "$",
                        name: "Default price",
                        restrict: "monetary",
                        disabled: franchiseManaged.value
                      }, null, 8, ["modelValue", "disabled"]),
                      (product.value?.attributes.type === 'GiftCardProduct')
                        ? (_openBlock(), _createBlock(_component_InputField, {
                            key: 0,
                            modelValue: local.giftCardValue,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((local.giftCardValue) = $event)),
                            prefix: "$",
                            name: "Gift card value",
                            restrict: "monetary",
                            disabled: franchiseManaged.value
                          }, null, 8, ["modelValue", "disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Price lists",
                  description: "Different prices for customers on a price list. Turn a list on to set its price for this product.",
                  plain: "",
                  onInput: _cache[12] || (_cache[12] = $event => (hasUnsavedChanges.value = true))
                }, {
                  default: _withCtx(() => [
                    (priceLists.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: priceListColumns,
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[102] || (_cache[102] = _createElementVNode("div", null, "Price list name", -1)),
                                      _cache[103] || (_cache[103] = _createElementVNode("div", null, "Price", -1)),
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_NeueButton, {
                                          type: "secondary",
                                          onClick: addPriceList
                                        }, {
                                          default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                                            _createTextVNode("+ List", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceLists.value, (list) => {
                                return (_openBlock(), _createBlock(TablistRow, {
                                  key: list.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, { columns: priceListColumns }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(list.attributes.price_list_name), 1),
                                        _createElementVNode("div", _hoisted_14, [
                                          _createElementVNode("div", _hoisted_15, [
                                            _createVNode(_component_NeueToggle, {
                                              "model-value": Boolean(local.priceListValues[list.id]),
                                              onChange: e => togglePriceList(list, e)
                                            }, null, 8, ["model-value", "onChange"]),
                                            _createVNode(_component_InputField, {
                                              modelValue: local.priceListValues[list.id],
                                              "onUpdate:modelValue": $event => ((local.priceListValues[list.id]) = $event),
                                              class: _normalizeClass(["w-32", !local.priceListValues[list.id] && 'invisible']),
                                              prefix: "$",
                                              restrict: "monetary"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                          _createVNode(_unref(XCircleIcon), {
                                            class: "h-6 w-6 cursor-pointer text-gray-700",
                                            onClick: _withModifiers($event => (deletePriceList(list)), ["stop"])
                                          }, null, 8, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!priceLists.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_EmptyState, { plural: "price lists" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NeueButton, {
                                type: "secondary",
                                onClick: addPriceList
                              }, {
                                default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                                  _createTextVNode("+ List", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Taxes",
                  description: "The tax code that decides how this product is taxed at checkout.",
                  onInput: _cache[15] || (_cache[15] = $event => (hasUnsavedChanges.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_SelectInput, {
                        modelValue: local.taxCode,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((local.taxCode) = $event)),
                        name: "Tax code",
                        disabled: franchiseManaged.value,
                        options: [
                      { name: '(None)', value: null },
                      ...taxCodes.value.map(x => ({
                        name: `${x.attributes.name} (${x.attributes.code})`,
                        value: x.attributes.code
                      }))
                    ],
                        onInput: _cache[14] || (_cache[14] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue", "disabled", "options"]),
                      (!selectedTaxCode.value?.attributes.name.startsWith(selectedTaxCode.value?.attributes.description))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(selectedTaxCode.value?.attributes.description), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Discounts",
                  description: "Whether discount codes can take money off this product.",
                  flush: ""
                }, {
                  default: _withCtx(() => [
                    _cache[105] || (_cache[105] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Exclude from discounts"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Customers cannot apply discount codes to this product. ")
                    ], -1)),
                    _createVNode(_component_NeueToggle, {
                      "model-value": product.value?.attributes.prevent_discounts,
                      "aria-label": "Exclude from discounts",
                      disabled: franchiseManaged.value,
                      onChange: _cache[16] || (_cache[16] = e => setAttribute('prevent_discounts', e))
                    }, null, 8, ["model-value", "disabled"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'pricing']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_19, [
                _createVNode(SettingsSection, {
                  title: "Inventory",
                  description: "Cap how many of this product can be sold. Once it runs out, customers cannot add it to their cart.",
                  onInput: _cache[19] || (_cache[19] = $event => (hasUnsavedChanges.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[106] || (_cache[106] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Limit inventory"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means there is no limit.")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        "model-value": product.value?.attributes.has_quantity_limit,
                        "aria-label": "Limit inventory",
                        onChange: _cache[17] || (_cache[17] = e => setAttribute('has_quantity_limit', e))
                      }, null, 8, ["model-value"])
                    ]),
                    (product.value?.attributes.has_quantity_limit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_InputField, {
                            modelValue: local.inventoryLimit,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((local.inventoryLimit) = $event)),
                            name: "Inventory limit",
                            type: "number",
                            class: "sm:max-w-xs"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Quantity settings",
                  description: "How many customers start with, how quantities step up, and what one of this product is called.",
                  onInput: _cache[23] || (_cache[23] = $event => (hasUnsavedChanges.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_FormElement, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: local.startingQuantity,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((local.startingQuantity) = $event)),
                            name: "Starting (minimum) quantity",
                            restrict: "integer",
                            disabled: franchiseManaged.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormElement, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: local.quantityName,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((local.quantityName) = $event)),
                            name: "Quantity name for a single item",
                            placeholder: "Leave blank for default",
                            disabled: franchiseManaged.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormElement, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: local.quantityStep,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((local.quantityStep) = $event)),
                            name: "Quantity step",
                            restrict: "integer",
                            disabled: franchiseManaged.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'inventory']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_23, [
                _createVNode(SettingsSection, {
                  title: "Variants",
                  description: "Choices customers make for this product, like size or add-ons. Drag to reorder variants and their options.",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(NeueTablist, { id: "sortable-variants" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: variant.id,
                            class: "draggable-source"
                          }, [
                            _createVNode(TablistHeader, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, [
                                  (!franchiseManaged.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, _toDisplayString(variant.attributes.name), 1)
                                ]),
                                (!franchiseManaged.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createVNode(_component_NeueButton, {
                                        type: "red",
                                        onClick: $event => (deleteVariant(variant))
                                      }, {
                                        default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                          _createTextVNode("Delete", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_component_NeueButton, {
                                        type: "secondary",
                                        onClick: $event => (editVariant(variant))
                                      }, {
                                        default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                                          _createTextVNode("Edit", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_component_NeueButton, {
                                        type: "secondary",
                                        onClick: $event => (addOption(variant))
                                      }, {
                                        default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                          _createTextVNode("+ Option", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            (variantOptions(variant).length)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["divide-y divide-gray-200", `sortable-options-${variant.id}`])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantOptions(variant), (option) => {
                                    return (_openBlock(), _createBlock(TablistRow, {
                                      key: option.id,
                                      class: "cursor-pointer",
                                      onClick: $event => (editOption(option))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_27, [
                                          (!franchiseManaged.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "cursor-move option-handle -ml-4 px-3 py-4",
                                                onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                                              }, [
                                                _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["font-semibold text-gray-700 truncate", {
                                'line-through':
                                  option.attributes.has_quantity_limit &&
                                  Number(option.attributes.inventory_remaining) === 0
                              }])
                                            }, [
                                              _createElementVNode("span", _hoisted_29, [
                                                _createTextVNode(_toDisplayString(option.attributes.name) + " ", 1),
                                                (option.attributes.has_quantity_limit)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, " (" + _toDisplayString(option.attributes.inventory_remaining) + " remaining) ", 1))
                                                  : _createCommentVNode("", true),
                                                (hasIngredientOverrides(option))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " (custom ingredient amounts) "))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ], 2)
                                          ]),
                                          (option.attributes.price.cents)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(formatPriceDelta)(option.attributes.price)), 1))
                                            : _createCommentVNode("", true),
                                          (!franchiseManaged.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                _createElementVNode("span", {
                                                  "data-test": "delete-option",
                                                  onClick: _withModifiers($event => (deleteOption(option)), ["stop"])
                                                }, [
                                                  _createVNode(_unref(XCircleIcon), { class: "h-5 w-5 cursor-pointer text-gray-700" })
                                                ], 8, _hoisted_34)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ], 2))
                              : _createCommentVNode("", true),
                            (!variantOptions(variant).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _cache[111] || (_cache[111] = _createElementVNode("div", { class: "mb-2" }, "No variant options", -1)),
                                  (!franchiseManaged.value)
                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                        key: 0,
                                        type: "secondary",
                                        onClick: $event => (addOption(variant))
                                      }, {
                                        default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                          _createTextVNode(" + Option ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, variants.value.length]
                    ]),
                    (variants.value.length && !franchiseManaged.value)
                      ? (_openBlock(), _createBlock(_component_NeueButton, {
                          key: 0,
                          type: "secondary",
                          class: "self-start",
                          onClick: addVariant
                        }, {
                          default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                            _createTextVNode(" + Variant ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!variants.value.length)
                      ? (_openBlock(), _createBlock(_component_EmptyState, {
                          key: 1,
                          plural: "variants",
                          class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                        }, {
                          default: _withCtx(() => [
                            (!franchiseManaged.value)
                              ? (_openBlock(), _createBlock(_component_NeueButton, {
                                  key: 0,
                                  type: "secondary",
                                  onClick: addVariant
                                }, {
                                  default: _withCtx(() => [...(_cache[113] || (_cache[113] = [
                                    _createTextVNode("+ Variant", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'variants']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_36, [
                _createVNode(SettingsSection, {
                  title: "Stores",
                  description: "The stores this product is sold in, and the category it sits under in each.",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    (pairs.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: storePairColumns,
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[115] || (_cache[115] = _createElementVNode("div", null, "Store", -1)),
                                      _cache[116] || (_cache[116] = _createElementVNode("div", null, "Category", -1)),
                                      _createElementVNode("div", _hoisted_38, [
                                        (!franchiseManaged.value)
                                          ? (_openBlock(), _createBlock(_component_NeueButton, {
                                              key: 0,
                                              type: "secondary",
                                              onClick: addPair
                                            }, {
                                              default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                                                _createTextVNode(" + Add to store ", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairs.value, (pair) => {
                                return (_openBlock(), _createBlock(TablistRow, {
                                  class: "cursor-pointer",
                                  onClick: $event => (editPair(pair))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, { columns: storePairColumns }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(pairStore(pair)?.attributes.store_name), 1),
                                        _createElementVNode("div", null, _toDisplayString(pairCategory(pair)?.attributes.category_name), 1),
                                        _createElementVNode("div", _hoisted_40, [
                                          (_unref(isFranchiseManaged)(pair))
                                            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                "data-test": "pair-lock",
                                                onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                                              }, [
                                                _createVNode(_unref(LockClosedIcon), { class: "h-5 w-5 ml-1 text-gray-400" })
                                              ])), [
                                                [_directive_tippy, { content: _unref(franchiseRecordLockText)(pair) }]
                                              ])
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                "data-test": "remove-pair",
                                                onClick: _withModifiers($event => (deletePair(pair)), ["stop"])
                                              }, [
                                                _createVNode(_unref(XCircleIcon), { class: "h-5 w-5 ml-1 cursor-pointer text-gray-700" })
                                              ], 8, _hoisted_41))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!pairs.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _cache[118] || (_cache[118] = _createElementVNode("svg", {
                            class: "mx-auto h-12 w-12 text-gray-400",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("path", {
                              "vector-effect": "non-scaling-stroke",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                            })
                          ], -1)),
                          _cache[119] || (_cache[119] = _createElementVNode("h3", { class: "mt-2 text-sm font-medium text-gray-900" }, "Not in any stores", -1)),
                          _cache[120] || (_cache[120] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Get started by adding this product to a store.", -1)),
                          (!franchiseManaged.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createVNode(_component_NeueButton, {
                                  type: "secondary",
                                  onClick: addPair
                                }, {
                                  default: _withCtx(() => [...(_cache[117] || (_cache[117] = [
                                    _createTextVNode("+ Add to store", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'stores']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_44, [
                _createVNode(SettingsSection, {
                  title: "Labels",
                  description: "Tags like vegan or gluten free that show on this product. Click a label's name to edit it."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      (parsleyLocked.value)
                        ? (_openBlock(), _createBlock(ParsleyLockNotice, {
                            key: 0,
                            link: parsleyLink.value
                          }, null, 8, ["link"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (label) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: '/store/labels/' + label.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NeueToggle, {
                              name: label.attributes.label_name,
                              "model-value": labelChecked(label),
                              disabled: labelLocked(label),
                              onChange: $event => (toggleLabel(label))
                            }, null, 8, ["name", "model-value", "disabled", "onChange"])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 256)),
                      (!parsleyLocked.value && !franchiseManaged.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createVNode(_component_InputField, {
                              modelValue: local.newLabel,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((local.newLabel) = $event)),
                              placeholder: "New label",
                              onKeyup: _cache[27] || (_cache[27] = _withKeys($event => (local.newLabel && createLabel()), ["enter"]))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_NeueButton, {
                              type: local.newLabel ? 'primary' : 'inactive',
                              onClick: createLabel
                            }, {
                              default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                                _createTextVNode(" + Label ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["type"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'labels']
              ]),
              (isFood.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(SettingsSection, {
                      title: "Ingredients",
                      description: "What goes into this product and how much of each.",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        (parsleyLocked.value)
                          ? (_openBlock(), _createBlock(ParsleyLockNotice, {
                              key: 0,
                              link: parsleyLink.value
                            }, null, 8, ["link"]))
                          : _createCommentVNode("", true),
                        (ingredients.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _createVNode(NeueTablist, null, {
                                head: _withCtx(() => [
                                  _createVNode(TablistHeader, null, {
                                    default: _withCtx(() => [
                                      _createVNode(TablistGrid, {
                                        columns: ingredientColumns,
                                        header: "",
                                        class: "items-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[123] || (_cache[123] = _createElementVNode("div", null, "Ingredient", -1)),
                                          _cache[124] || (_cache[124] = _createElementVNode("div", null, "Amount", -1)),
                                          _cache[125] || (_cache[125] = _createElementVNode("div", null, "Contains", -1)),
                                          _createElementVNode("div", _hoisted_49, [
                                            (!nutritionLocked.value)
                                              ? (_openBlock(), _createBlock(_component_NeueButton, {
                                                  key: 0,
                                                  type: "secondary",
                                                  onClick: addIngredient
                                                }, {
                                                  default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                                                    _createTextVNode(" + Ingredient ", -1)
                                                  ]))]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ingredients.value, (ingredient) => {
                                    return (_openBlock(), _createBlock(TablistRow, {
                                      class: "cursor-pointer",
                                      onClick: $event => (editIngredient(ingredient))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(TablistGrid, {
                                          columns: ingredientColumns,
                                          class: "items-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_50, _toDisplayString(ingredient.attributes.name), 1),
                                            _createElementVNode("div", _hoisted_51, _toDisplayString(ingredient.attributes.amount) + " " + _toDisplayString(ingredient.attributes.measurement), 1),
                                            _createElementVNode("div", _hoisted_52, _toDisplayString(ingredient.attributes.contains), 1),
                                            _createElementVNode("div", _hoisted_53, [
                                              (!nutritionLocked.value)
                                                ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                                    key: 0,
                                                    class: "h-5 w-5 cursor-pointer text-gray-700",
                                                    onClick: _withModifiers($event => (deleteIngredient(ingredient)), ["stop"])
                                                  }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 256))
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (!ingredients.value.length)
                          ? (_openBlock(), _createBlock(_component_EmptyState, {
                              key: 2,
                              plural: "ingredients",
                              class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                            }, {
                              default: _withCtx(() => [
                                (!nutritionLocked.value)
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 0,
                                      type: "secondary",
                                      onClick: addIngredient
                                    }, {
                                      default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                        _createTextVNode("+ Ingredient", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(SettingsSection, {
                      title: "Nutritional information",
                      description: "Per-serving nutrition facts shown on the product page.",
                      onInput: _cache[45] || (_cache[45] = $event => (hasUnsavedChanges.value = true))
                    }, {
                      default: _withCtx(() => [
                        (parsleyLocked.value)
                          ? (_openBlock(), _createBlock(ParsleyLockNotice, {
                              key: 0,
                              link: parsleyLink.value
                            }, null, 8, ["link"]))
                          : _createCommentVNode("", true),
                        false
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-xs px-5 py-2.5 text-center me-2 mb-2",
                              disabled: aiLoading.value,
                              onClick: useAI
                            }, [
                              _cache[127] || (_cache[127] = _createElementVNode("span", { style: {"margin-right":"2px"} }, "ϟ", -1)),
                              _createTextVNode(" " + _toDisplayString(aiLoading.value ? 'Processing...' : 'Use AI'), 1)
                            ], 8, _hoisted_54))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.servingSize,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((local.nutritional.servingSize) = $event)),
                                name: "Serving size",
                                restrict: "float",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.servingSizeName,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => ((local.nutritional.servingSizeName) = $event)),
                                name: "Serving size name (singular)",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.servingsPerContainer,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((local.nutritional.servingsPerContainer) = $event)),
                                name: "Servings per container",
                                restrict: "float",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.calories,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((local.nutritional.calories) = $event)),
                                name: "Calories",
                                restrict: "integer",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.totalFat,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((local.nutritional.totalFat) = $event)),
                                name: "Total fat",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.saturatedFat,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => ((local.nutritional.saturatedFat) = $event)),
                                name: "Saturated fat",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.transFat,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => ((local.nutritional.transFat) = $event)),
                                name: "Trans fat",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.protein,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => ((local.nutritional.protein) = $event)),
                                name: "Protein",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.totalCarbs,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => ((local.nutritional.totalCarbs) = $event)),
                                name: "Total carbs",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.dietaryFiber,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => ((local.nutritional.dietaryFiber) = $event)),
                                name: "Dietary fiber",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.sugars,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => ((local.nutritional.sugars) = $event)),
                                name: "Sugars",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.addedSugar,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => ((local.nutritional.addedSugar) = $event)),
                                name: "Added sugar",
                                restrict: "float",
                                suffix: "g",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.cholesterol,
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => ((local.nutritional.cholesterol) = $event)),
                                name: "Cholesterol",
                                restrict: "float",
                                suffix: "mg",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.sodium,
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => ((local.nutritional.sodium) = $event)),
                                name: "Sodium",
                                restrict: "float",
                                suffix: "mg",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.iron,
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => ((local.nutritional.iron) = $event)),
                                name: "Iron",
                                restrict: "float",
                                suffix: "mg",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.vitaminD,
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => ((local.nutritional.vitaminD) = $event)),
                                name: "Vitamin D",
                                restrict: "float",
                                suffix: "mcg",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormElement, { size: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputField, {
                                modelValue: local.nutritional.vitaminC,
                                "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => ((local.nutritional.vitaminC) = $event)),
                                name: "Vitamin C",
                                restrict: "float",
                                suffix: "mg",
                                disabled: nutritionLocked.value
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ], 512)), [
                    [_vShow, _unref(activeTab) === 'nutrition']
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_56, [
                _createVNode(SettingsSection, {
                  title: "Actions",
                  description: "Copy this product to start a new one from it, or delete it."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[129] || (_cache[129] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Copy product"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Makes a new product with the same details.")
                      ], -1)),
                      _createVNode(_component_NeueButton, {
                        type: "secondary",
                        onClick: copyProduct
                      }, {
                        default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                          _createTextVNode("Copy", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    (!franchiseManaged.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _cache[131] || (_cache[131] = _createElementVNode("div", { class: "min-w-0" }, [
                            _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Delete product"),
                            _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Removes it from every store. This cannot be undone. ")
                          ], -1)),
                          _createVNode(_component_NeueButton, {
                            type: "red",
                            onClick: deleteProduct
                          }, {
                            default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                              _createTextVNode("Delete", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'actions']
              ])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_TheModal, {
            "is-open": priceListModal.open,
            "modal-title": "Add price list",
            onCloseModal: _cache[48] || (_cache[48] = $event => (priceListModal.open = false))
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: priceListModal.name,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => ((priceListModal.name) = $event)),
                        name: "Name",
                        placeholder: "Price list name",
                        onKeyup: _withKeys(savePriceListModal, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: _cache[47] || (_cache[47] = $event => (priceListModal.open = false))
              }, {
                default: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: priceListModal.name ? 'primary' : 'inactive',
                onClick: savePriceListModal
              }, {
                default: _withCtx(() => [...(_cache[133] || (_cache[133] = [
                  _createTextVNode(" Save ", -1)
                ]))]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_TheModal, {
            "is-open": variantModal.open,
            "modal-title": variantModal.id ? 'Edit variant' : 'Add variant',
            onCloseModal: _cache[56] || (_cache[56] = $event => (variantModal.open = false))
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: variantModal.name,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => ((variantModal.name) = $event)),
                        name: "Name",
                        onKeyup: _withKeys(saveVariantModal, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectInput, {
                        modelValue: variantModal.quantityOption,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => ((variantModal.quantityOption) = $event)),
                        name: "Quantity option",
                        options: [
                      { name: 'Choose one', value: 'choose_one' },
                      { name: 'Choose many', value: 'choose_many' },
                      { name: 'Custom quantities (bundle)', value: 'custom_quantities' }
                    ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (variantModal.quantityOption === 'custom_quantities')
                    ? (_openBlock(), _createBlock(_component_FormElement, {
                        key: 0,
                        size: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: variantModal.minimum,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => ((variantModal.minimum) = $event)),
                            name: "Minimum allowed to select",
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (variantModal.quantityOption === 'custom_quantities')
                    ? (_openBlock(), _createBlock(_component_FormElement, {
                        key: 1,
                        size: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: variantModal.maximum,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => ((variantModal.maximum) = $event)),
                            name: "Maximum allowed to select",
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueCheckbox, {
                        modelValue: variantModal.required,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => ((variantModal.required) = $event)),
                        name: "Required"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueCheckbox, {
                        modelValue: variantModal.visible,
                        "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => ((variantModal.visible) = $event)),
                        name: "Visible to the customer"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: _cache[55] || (_cache[55] = $event => (variantModal.open = false))
              }, {
                default: _withCtx(() => [...(_cache[134] || (_cache[134] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: variantModal.name ? 'primary' : 'inactive',
                onClick: saveVariantModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(variantModal.id ? 'Save' : 'Add'), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open", "modal-title"]),
          _createVNode(_component_TheModal, {
            "is-open": optionModal.open,
            "modal-title": optionModal.id ? 'Edit variant option' : 'Add variant option',
            "has-tabs": true,
            tabs: [
              { id: 'main', name: 'Variant Option' },
              { id: 'secondary', name: 'Nutritional Information' },
              { id: 'ingredients', name: 'Ingredients' }
            ],
            onCloseModal: _cache[86] || (_cache[86] = $event => (optionModal.open = false))
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: optionModal.name,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => ((optionModal.name) = $event)),
                        name: "Name",
                        disabled: Boolean(optionModal.id),
                        description: Boolean(optionModal.id) && 'Create a new variant option to change the name.',
                        onKeyup: _withKeys(saveOptionModal, ["enter"])
                      }, null, 8, ["modelValue", "disabled", "description"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: optionModal.matchName,
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => ((optionModal.matchName) = $event)),
                        name: "Name for matching",
                        placeholder: "(Optional, not shown to customer)",
                        disabled: franchiseManaged.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: optionModal.description,
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => ((optionModal.description) = $event)),
                        name: "Description",
                        placeholder: "(Optional)",
                        disabled: franchiseManaged.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _cache[135] || (_cache[135] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Upcharge/Discount on Base Price", -1)),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(SegmentedControl, {
                          modelValue: optionModal.priceSign,
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => ((optionModal.priceSign) = $event)),
                          options: _unref(priceDeltaSignOptions),
                          disabled: franchiseManaged.value
                        }, null, 8, ["modelValue", "options", "disabled"]),
                        _createVNode(_component_InputField, {
                          modelValue: optionModal.price,
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => ((optionModal.price) = $event)),
                          prefix: "$",
                          restrict: "monetary",
                          "aria-label": "Price change amount",
                          class: "w-32",
                          disabled: franchiseManaged.value
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueToggle, {
                        modelValue: optionModal.hasQuantityLimit,
                        "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => ((optionModal.hasQuantityLimit) = $event)),
                        name: "Limit inventory"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (optionModal.hasQuantityLimit)
                    ? (_openBlock(), _createBlock(_component_FormElement, {
                        key: 0,
                        size: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: optionModal.inventoryRemaining,
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => ((optionModal.inventoryRemaining) = $event)),
                            name: "Inventory limit",
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: _cache[64] || (_cache[64] = $event => (optionModal.open = false))
              }, {
                default: _withCtx(() => [...(_cache[136] || (_cache[136] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: optionModal.name ? 'primary' : 'inactive',
                onClick: saveOptionModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(optionModal.id ? 'Save' : 'Add'), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ]),
            secondary: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueCheckbox, {
                        modelValue: optionModal.hasNutritionalInfo,
                        "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => ((optionModal.hasNutritionalInfo) = $event)),
                        name: "Include nutritional information",
                        disabled: franchiseManaged.value,
                        onChange: _cache[66] || (_cache[66] = $event => (!optionModal.hasNutritionalInfo && clearNutritionalInfo()))
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  (optionModal.hasNutritionalInfo)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_unref(InformationCircleIcon), { class: "h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" }),
                              _cache[137] || (_cache[137] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " Nutrition facts entered here are added to or subtracted from the base product's nutrition facts. For required variants, values are also combined with any other selected required variant options. Enter positive values to add nutrients, or negative values to subtract. ", -1))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, { size: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.serving_size,
                              "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => ((optionModal.nutritional_information.serving_size) = $event)),
                              name: "Serving Size",
                              type: "number",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, { size: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.serving_size_title_singular,
                              "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => ((optionModal.nutritional_information.serving_size_title_singular) = $event)),
                              name: "Serving Size Name (singular)",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.servings_per_container,
                              "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => ((optionModal.nutritional_information.servings_per_container) = $event)),
                              name: "Servings Per Container",
                              type: "number",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.calories,
                              "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => ((optionModal.nutritional_information.calories) = $event)),
                              name: "Calories",
                              type: "number",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.total_fat,
                              "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => ((optionModal.nutritional_information.total_fat) = $event)),
                              name: "Total Fat",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.saturated_fat,
                              "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => ((optionModal.nutritional_information.saturated_fat) = $event)),
                              name: "Saturated Fat",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.trans_fat,
                              "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => ((optionModal.nutritional_information.trans_fat) = $event)),
                              name: "Trans Fat",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.protein,
                              "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => ((optionModal.nutritional_information.protein) = $event)),
                              name: "Protein",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.total_carbs,
                              "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => ((optionModal.nutritional_information.total_carbs) = $event)),
                              name: "Total Carbs",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.dietary_fiber,
                              "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => ((optionModal.nutritional_information.dietary_fiber) = $event)),
                              name: "Dietary Fiber",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.sugars,
                              "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => ((optionModal.nutritional_information.sugars) = $event)),
                              name: "Sugars",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.added_sugar,
                              "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => ((optionModal.nutritional_information.added_sugar) = $event)),
                              name: "Added Sugar",
                              type: "number",
                              suffix: "g",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.cholesterol,
                              "onUpdate:modelValue": _cache[79] || (_cache[79] = $event => ((optionModal.nutritional_information.cholesterol) = $event)),
                              name: "Cholesterol",
                              type: "number",
                              suffix: "mg",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.sodium,
                              "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => ((optionModal.nutritional_information.sodium) = $event)),
                              name: "Sodium",
                              type: "number",
                              suffix: "mg",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.iron,
                              "onUpdate:modelValue": _cache[81] || (_cache[81] = $event => ((optionModal.nutritional_information.iron) = $event)),
                              name: "Iron",
                              type: "number",
                              suffix: "mg",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.vitamin_d,
                              "onUpdate:modelValue": _cache[82] || (_cache[82] = $event => ((optionModal.nutritional_information.vitamin_d) = $event)),
                              name: "Vitamin D",
                              type: "number",
                              suffix: "mcg",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: optionModal.nutritional_information.vitamin_c,
                              "onUpdate:modelValue": _cache[83] || (_cache[83] = $event => ((optionModal.nutritional_information.vitamin_c) = $event)),
                              name: "Vitamin C",
                              type: "number",
                              suffix: "mg",
                              disabled: franchiseManaged.value
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            "secondary-footer": _withCtx(() => [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_NeueButton, {
                  type: "secondary",
                  onClick: _cache[84] || (_cache[84] = $event => (optionModal.open = false))
                }, {
                  default: _withCtx(() => [...(_cache[138] || (_cache[138] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_NeueButton, {
                  type: optionModal.name ? 'primary' : 'inactive',
                  onClick: saveOptionModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(optionModal.id ? 'Save' : 'Add'), 1)
                  ]),
                  _: 1
                }, 8, ["type"])
              ])
            ]),
            ingredients: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _cache[140] || (_cache[140] = _createElementVNode("div", { class: "text-sm text-gray-500 mb-3" }, " Amounts used for the ingredients report when this option is selected. Leave an amount at the product value to keep it, set it to 0 to leave the ingredient out. ", -1)),
                      (optionModal.ingredientRows?.length)
                        ? (_openBlock(), _createBlock(NeueTablist, { key: 0 }, {
                            head: _withCtx(() => [
                              _createVNode(TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: optionIngredientColumns,
                                    header: "",
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                                      _createElementVNode("div", null, "Ingredient", -1),
                                      _createElementVNode("div", null, "Product amount", -1),
                                      _createElementVNode("div", null, "Amount for this option", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionModal.ingredientRows, (row) => {
                                return (_openBlock(), _createBlock(TablistRow, {
                                  key: row.key
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, {
                                      columns: optionIngredientColumns,
                                      class: "items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_62, _toDisplayString(row.name), 1),
                                        _createElementVNode("div", _hoisted_63, [
                                          (row.baseAmount !== null)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(row.baseAmount) + " " + _toDisplayString(row.measurement), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("Not on product")
                                              ], 64))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_InputField, {
                                            modelValue: row.amount,
                                            "onUpdate:modelValue": $event => ((row.amount) = $event),
                                            restrict: "float",
                                            suffix: row.measurement,
                                            disabled: franchiseManaged.value
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix", "disabled"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!optionModal.ingredientRows?.length)
                        ? (_openBlock(), _createBlock(_component_EmptyState, {
                            key: 1,
                            plural: "ingredients",
                            description: "Add ingredients to the product first, then set amounts for this option."
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            "ingredients-footer": _withCtx(() => [
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_NeueButton, {
                  type: "secondary",
                  onClick: _cache[85] || (_cache[85] = $event => (optionModal.open = false))
                }, {
                  default: _withCtx(() => [...(_cache[141] || (_cache[141] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_NeueButton, {
                  type: optionModal.name ? 'primary' : 'inactive',
                  onClick: saveOptionModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(optionModal.id ? 'Save' : 'Add'), 1)
                  ]),
                  _: 1
                }, 8, ["type"])
              ])
            ]),
            _: 1
          }, 8, ["is-open", "modal-title"]),
          _createVNode(_component_TheModal, {
            "is-open": newPairModal.open,
            "modal-title": "Add product to store",
            onCloseModal: _cache[90] || (_cache[90] = $event => (newPairModal.open = false))
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectInput, {
                        modelValue: newPairModal.store,
                        "onUpdate:modelValue": _cache[87] || (_cache[87] = $event => ((newPairModal.store) = $event)),
                        name: "Store",
                        placeholder: "Select store",
                        options: 
                      stores.value.map(x => ({
                        name: x.attributes.store_name,
                        value: x.id
                      }))
                    
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectInput, {
                        modelValue: newPairModal.category,
                        "onUpdate:modelValue": _cache[88] || (_cache[88] = $event => ((newPairModal.category) = $event)),
                        name: "Category",
                        placeholder: "Select category",
                        disabled: !newPairModal.store,
                        options: 
                      storeCategories(_unref(mapRelationship)({ type: 'store', id: newPairModal.store })).map(x => ({
                        name: x.attributes.category_name,
                        value: x.id
                      }))
                    
                      }, null, 8, ["modelValue", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: _cache[89] || (_cache[89] = $event => (newPairModal.open = false))
              }, {
                default: _withCtx(() => [...(_cache[142] || (_cache[142] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: newPairModal.store && newPairModal.category ? 'primary' : 'inactive',
                onClick: saveNewPair
              }, {
                default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                  _createTextVNode(" Add ", -1)
                ]))]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_unref(CPSPModal), {
            id: modalPair.value?.id,
            open: local.cpspModalOpen,
            onCloseModal: _cache[91] || (_cache[91] = $event => (local.cpspModalOpen = false))
          }, null, 8, ["id", "open"]),
          _createVNode(_component_TheModal, {
            "is-open": ingredientsModal.open,
            "modal-title": ingredientsModal.new ? 'Add ingredient' : 'Edit ingredient',
            onCloseModal: _cache[97] || (_cache[97] = $event => (ingredientsModal.open = false))
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: ingredientsModal.name,
                        "onUpdate:modelValue": _cache[92] || (_cache[92] = $event => ((ingredientsModal.name) = $event)),
                        name: "Name",
                        placeholder: "Ingredient name",
                        onKeyup: _withKeys(saveIngredientsModal, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputArea, {
                        modelValue: ingredientsModal.contains,
                        "onUpdate:modelValue": _cache[93] || (_cache[93] = $event => ((ingredientsModal.contains) = $event)),
                        name: "Contains",
                        placeholder: "Paprika, salt, etc. (optional)",
                        onKeyup: _withKeys(saveIngredientsModal, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, { size: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: ingredientsModal.amount,
                        "onUpdate:modelValue": _cache[94] || (_cache[94] = $event => ((ingredientsModal.amount) = $event)),
                        name: "Amount",
                        placeholder: "0.5",
                        restrict: "float",
                        onKeyup: _withKeys(saveIngredientsModal, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, { size: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectInput, {
                        modelValue: ingredientsModal.measurement,
                        "onUpdate:modelValue": _cache[95] || (_cache[95] = $event => ((ingredientsModal.measurement) = $event)),
                        name: "Measurement",
                        options: _unref(ingredientMeasurementOptions)
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: _cache[96] || (_cache[96] = $event => (ingredientsModal.open = false))
              }, {
                default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: ingredientsModal.name ? 'primary' : 'inactive',
                onClick: saveIngredientsModal
              }, {
                default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                  _createTextVNode(" Save ", -1)
                ]))]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open", "modal-title"])
        ]),
        _createVNode(_component_PageFooter, null, {
          right: _withCtx(() => [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createBlock(_component_NeueButton, {
                  key: 0,
                  type: "primary",
                  onClick: save
                }, {
                  default: _withCtx(() => [...(_cache[146] || (_cache[146] = [
                    _createTextVNode("Save", -1)
                  ]))]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: doneLink.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NeueButton, { type: "primary" }, {
                      default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                        _createTextVNode("Done", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
          ]),
          _: 1
        })
      ], 512)
    ]),
    _: 2
  }, [
    (storeId.value)
      ? {
          name: "sidebar",
          fn: _withCtx(() => [
            _createVNode(_unref(StoreSectionsNav), { "store-id": storeId.value }, null, 8, ["store-id"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

}